/**
 * Vite entry — loads global styles then the existing app bootstrap (js/app.js self-inits).
 */
import '../styles.css';
import '../js/app.js';

// Centralized Google Analytics Tracking
window.addEventListener('fg:navigate', (e) => {
    const pageName = e.detail.page;
    if (typeof gtag === 'function') {
        gtag('event', 'page_view', {
            page_title: pageName,
            page_path: window.location.pathname + window.location.search + window.location.hash
        });
    }
});
